import { H1 } from '../components';
import { Box } from '@mui/material';

function SchoolPage() {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      gap={3}
      sx={{ textAlign: 'center', py: 4 }}
    >
      <H1>School</H1>
    </Box>
  );
}

export default SchoolPage;
